const cdlMap = (props) => {
    return (
        <div className="cdl-map" {...props}>
            <iframe 
                title="CDL Map"
                allowFullScreen=""
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2508.221673579331!2d-114.07703358435882!3d51.04899455193669!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53716fe4cf6165cf%3A0x320e70755a39879!2s622+5+Ave+SW%2C+Calgary%2C+AB+T2P!5e0!3m2!1sen!2sca!4v1511213168519">
            </iframe>
        </div>
    )
}

export default cdlMap